/** en-GB locale → DD/MM/YYYY numeric (not US month-first). */
const UK_NUMERIC = { day: "2-digit", month: "2-digit", year: "numeric" };

export function formatDateUk(value) {
  if (value == null || value === "") return "N/A";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "N/A";
  return d.toLocaleDateString("en-GB", UK_NUMERIC);
}
